import { render, staticRenderFns } from "./MdtLoader.vue?vue&type=template&id=41868654&scoped=true"
import script from "./MdtLoader.vue?vue&type=script&lang=js"
export * from "./MdtLoader.vue?vue&type=script&lang=js"
import style0 from "./MdtLoader.vue?vue&type=style&index=0&id=41868654&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41868654",
  null
  
)

export default component.exports